import { render, staticRenderFns } from "./CoreSuperiority.vue?vue&type=template&id=11f0d6b4&scoped=true&"
import script from "./CoreSuperiority.vue?vue&type=script&lang=js&"
export * from "./CoreSuperiority.vue?vue&type=script&lang=js&"
import style0 from "./CoreSuperiority.vue?vue&type=style&index=0&id=11f0d6b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f0d6b4",
  null
  
)

export default component.exports